import { render, staticRenderFns } from "./ProgramTabMain.vue?vue&type=template&id=f8e6a666&"
import script from "./ProgramTabMain.vue?vue&type=script&lang=js&"
export * from "./ProgramTabMain.vue?vue&type=script&lang=js&"
import style0 from "./ProgramTabMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports